export const sliceText = (text = '', maxChars = 150) => {
  let lastIndex = maxChars;
  if (text.length < maxChars) return text;
  while (text[lastIndex] !== ' ') lastIndex--;
  return text.substring(0, lastIndex) + '...';
};
